export function parsePesoToCentavos(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return 0;

  const cleaned = raw.replace(/[^\d.]/g, "");
  if (!cleaned || cleaned === ".") return 0;

  const firstDot = cleaned.indexOf(".");
  const wholeRaw = firstDot === -1 ? cleaned : cleaned.slice(0, firstDot);
  const fracRaw = firstDot === -1 ? "" : cleaned.slice(firstDot + 1).replace(/\./g, "");
  const whole = Number.parseInt(wholeRaw || "0", 10);
  if (!Number.isFinite(whole)) return 0;

  const centsBase = Number.parseInt((fracRaw + "00").slice(0, 2), 10) || 0;
  const roundUp = Number.parseInt(fracRaw[2] || "0", 10) >= 5 ? 1 : 0;
  return Math.max(0, whole * 100 + centsBase + roundUp);
}

export function centavosToPesoInput(centavos) {
  const safe = Number.isFinite(Number(centavos)) ? Math.max(0, Math.round(Number(centavos))) : 0;
  return (safe / 100).toFixed(2);
}

export function calculatePercentDiscountCentavos(amountCentavos, percent) {
  const amount = Number.isFinite(Number(amountCentavos)) ? Math.max(0, Math.round(Number(amountCentavos))) : 0;
  const basisPoints = Number.isFinite(Number(percent)) ? Math.max(0, Math.round(Number(percent) * 100)) : 0;
  return Math.round((amount * basisPoints) / 10000);
}

export function formatPercentLabel(percent) {
  const value = Number(percent);
  if (!Number.isFinite(value)) return "";
  return `${(Math.round(value * 100) / 100).toString().replace(/\.0+$/, "")}%`;
}
